import listTemplateUrl from "emun.cust/locations/ship-location-list.htm";

export default ({
  mode = "shiplocation",
  menu,
  base = menu ? `${menu}.${mode}` : mode,
  nav = 1,
  icon = "truck",
  title = "Ship Locations",
  url = `/${mode}`,
  breadcrumbs = false,
  pageHeader = false,
} = {}) => {
  const states = {
    [base]: {
      url: `${url}?pending&status&retailerId&customerId&state&zip&nameStartsWith&idStartsWith`,
      menu,
      nav,
      icon,
      title,
      breadcrumbs,
      pageHeader,
      resolve: {
        // proxy: ($window) =>
        //   this.isProxy && $window.location.replace(`${this.baseUrl}#/cust`),
      },
      rerouteTo: `${base}.list`,
      templateProvider: ($stateParams) => `
      <ship-location-container 
        ${
          $stateParams.pending
            ? 'pending="true"'
            : $stateParams.status
            ? `status="${$stateParams.status}"`
            : ""
        }
        ${
          $stateParams.retailerId
            ? `retailer-id="${$stateParams.retailerId}"`
            : $stateParams.customerId
            ? `customer-id="${$stateParams.customerId}"`
            : ""
        }
      />`,
    },
    [`${base}.list`]: {
      menu: base,
      nav: false,
      breadcrumbs: false,
      pageHeader: false,
      title,
      templateUrl: listTemplateUrl,
    },
  };

  // console.debug("shipping-locations States", states);
  return states;
};
